$('#search').on('click', function() {
  if(!$(this).hasClass('active')) {
    $(this).addClass('active');
    $('.search').addClass('search--open');
    $('.mask').fadeIn(400);
  } else {
    $(this).removeClass('active');
    $('.search').removeClass('search--open')
    $('.mask').fadeOut(400);
  }
})